import { Component } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { InputNumberModule } from 'primeng/inputnumber';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'pm-form-field-number',
  imports: [ReactiveFormsModule, InputNumberModule],
  templateUrl: './pm-form-field-number.component.html',
  styleUrl: './pm-form-field-number.component.scss',
})
export class PmFormFieldNumberComponent extends FormFieldComponent {}
